export default __webpack_public_path__ + "static/media/woman-with-notebook.a83788e4.png";